import React from 'react';
import '../Events/event.css';
import image from '../Events/week.jpeg';
import img from '../../Components/Images/image.webp';
import img1 from '../../Components/Images/image1.webp';
import img2 from '../../Components/Images/image2.webp';
import img3 from '../../Components/Images/image3.webp';
import img4 from '../../Components/Images/image4.webp';
import img5 from '../../Components/Images/image5.webp';
import Gallery from '../Gallery/gallery';

const Pharmocoviglance = () => {
    const images = [
        {
            src: img,
            alt: "Image"
        },
        {
            src: img1,
            alt: "Image"
        }, {
            src: img2,
            alt: "Image"
        }, {
            src: img3,
            alt: "Image"
        }, {
            src: img4,
            alt: "Image"
        }, {
            src: img5,
            alt: "Image"
        },

    ]
    return (
        <>
            <section className="about">
                <div className="main">
                    <img src={image} alt="About Us" />
                    <div className="all-text">
                        <h1>Pharmocoviglance Week</h1>
                        <p>
                            The Pharmacovigilance Week was a comprehensive initiative to educate and engage students and the community in pharmacovigilance, culminating in a successful event that promoted awareness and knowledge about the subject.
                            The Pharmacovigilance Week, organized over a span of seven days, aimed at boosting public confidence in pharmacovigilance. Here's a summary of the event's activities:
                        </p>
                        <p>
                            Day 1: The week began with an orientation session where students were informed about the exciting events ahead. The ceremony started with the auspicious lamp lighting. The Dean and Cluster Heads of SOHST addressed the audience. A highlight of the day was an expert talk on "Global Pharmacovigilance Initiatives and India's Perspective" by Dr. S. K. Singh, CMO, Infirmary.
                        </p>
                        <p>Day 2: The focus shifted to awareness campaigns in local schools, where students from various departments took the initiative to spread knowledge about pharmacovigilance.
                        </p>
                        <p>Day 3: Dr. Shubham Dwivedi, the faculty advisor of Ozone, delivered an expert talk, adding depth to the understanding of pharmacovigilance.
                        </p>
                        <p>Day 4: Similar awareness programs were conducted in anganwadis, contributing to the outreach efforts.
                        </p>
                        <p>Day 5: On this day, students were sensitized about the competitions to be held in the last two days, ensuring their active participation.
                        </p>
                        <p>Day 6: The event featured a face painting competition, adding a creative and engaging aspect to pharmacovigilance awareness
                        </p>
                        <p>Day 7: The closing ceremony marked the end of the week-long event. Awards were distributed for the various competitions held throughout the week, recognizing the efforts of the participants.
                        </p>
                    </div>
                </div>
            </section>
            <Gallery images={images} />
        </>
    );
};

export default Pharmocoviglance;
